import { cn } from "@/lib/utils";

export const TIER_META = {
  TIER_FREE: { label: "TIER_FREE", cls: "bg-emerald-950/70 text-emerald-300 border-emerald-800" },
  TIER_PRO: { label: "TIER_PRO", cls: "bg-sky-950/70 text-sky-300 border-sky-800" },
  TIER_ENTERPRISE_HR: { label: "TIER_ENTERPRISE_HR", cls: "bg-amber-950/70 text-amber-300 border-amber-800" },
  TIER_RESTRICTED: { label: "TIER_RESTRICTED", cls: "bg-red-950/70 text-red-300 border-red-800" },
};

const VERDICT_META = {
  APPROVE: { cls: "bg-emerald-950/70 text-emerald-300 border-emerald-700", dot: "bg-emerald-400" },
  REVIEW: { cls: "bg-amber-950/70 text-amber-300 border-amber-700", dot: "bg-amber-400" },
  REJECT: { cls: "bg-red-950/70 text-red-300 border-red-700", dot: "bg-red-400" },
};

const STATUS_META = {
  APPROVED: "text-emerald-400",
  PENDING_REVIEW: "text-amber-400",
  REJECTED: "text-red-400",
  ESCALATED: "text-fuchsia-400",
};

export function VerdictBadge({ verdict, className, testid }) {
  const m = VERDICT_META[verdict] || VERDICT_META.REVIEW;
  return (
    <span
      data-testid={testid || "verdict-badge"}
      className={cn(
        "inline-flex items-center gap-2 rounded-full border px-3 py-1 font-mono text-xs font-semibold uppercase tracking-wider",
        m.cls,
        className
      )}
    >
      <span className={cn("h-2 w-2 rounded-full", m.dot)} />
      {verdict}
    </span>
  );
}

export function TierBadge({ tier, className }) {
  const m = TIER_META[tier] || TIER_META.TIER_FREE;
  return (
    <span
      data-testid="tier-badge"
      className={cn(
        "inline-flex items-center rounded-md border px-2.5 py-1 font-mono text-[11px] font-semibold tracking-wide",
        m.cls,
        className
      )}
    >
      {m.label}
    </span>
  );
}

export function StatusText({ status }) {
  return (
    <span className={cn("font-mono text-xs font-semibold", STATUS_META[status] || "text-slate-400")}>
      {status}
    </span>
  );
}

export function riskColorFromScore(score) {
  return score <= 2 ? "Green" : score <= 5 ? "Yellow" : "Red";
}

const RISK_DOT = { Green: "bg-emerald-400", Yellow: "bg-amber-400", Red: "bg-red-400" };

export function RiskDot({ score, color }) {
  const c = color || riskColorFromScore(score ?? 0);
  return (
    <span
      data-testid="risk-dot"
      title={`${c} risk`}
      className={cn("inline-block h-2.5 w-2.5 rounded-full", RISK_DOT[c] || "bg-slate-500")}
    />
  );
}

export function RiskColorBadge({ color, score }) {
  const c = color || riskColorFromScore(score ?? 0);
  const cls = {
    Green: "bg-emerald-950/70 text-emerald-300 border-emerald-800",
    Yellow: "bg-amber-950/70 text-amber-300 border-amber-800",
    Red: "bg-red-950/70 text-red-300 border-red-800",
  };
  return (
    <span
      data-testid="risk-color-badge"
      className={cn("inline-flex items-center gap-1.5 rounded-md border px-2 py-0.5 font-mono text-[11px] font-semibold", cls[c] || "")}
    >
      <span className={cn("h-2 w-2 rounded-full", RISK_DOT[c])} />
      {c}
    </span>
  );
}
